<template>
  <div>
    <div id="Duty"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "Duty",
  data() {
    return {
      colorList: ['rgba(89,89,215,1)', 'rgba(192,196,204,1)', 'rgb(65,228,222)', 'rgb(50,184,240)'],
      colorList2: ['rgba(89,89,215,.6)', 'rgba(192,196,204,.6)', 'rgba(65,228,222,.6)', 'rgba(50,184,240,.6)'],
      DutyCharts: null,
      options: {
        tooltip: {
          trigger: 'item',
        },
        graphic: {
          type: 'text',
          left: '45%',
          top: '35%',
          style: {
            text: null,
            fill: '#fff',
            font: '.9rem "STHeiti", sans-serif',
          }
        },
        title: { // 第一个圆环标题
          text: "值班备勤", // 主标题
          textStyle: { // 主标题样式
            color: '#BCCBEF',
            fontSize: '.7rem',
            fontWeight: '500',
          },
          left: '45%',
          top: '45%', // 定位到适合的位置
          subtext: '（个）', // 副标题
          subtextStyle: { // 副标题样式
            color: '#287CE8',
            fontSize: '.6rem',
            fontWeight: '500',
            lineHeight: 5,
          },
          textAlign: 'center'
        },
        series: [
          {
            name: '值班备勤',
            type: 'pie',
            radius: ['80%', '90%'],
            emphasis: {
              scale: false,
            },
            label: {
              show: false,
            },
            minAngle: 30,//最小角度
            avoidLabelOverlap: false,
            data: [],
            itemStyle: {
              color: 'rgba(110,110,248,0.6)',
            }
          }, {
            name: '值班备勤',
            type: 'pie',
            minAngle: 30,//最小角度
            radius: ['60%', '83%'],
            emphasis: {
              scale: false,
            },
            label: {
              show: false
            },
            avoidLabelOverlap: false,
            data: [],
            itemStyle: {
              color: 'rgba(89,89,215,.6)',
            }
          }
        ]
      }
    }
  },
  mounted() {
    this.getDutyPercentage()
  },
  methods: {
    initCharts() {
      let DutyCharts = document.getElementById('Duty');
      this.DutyCharts = echarts.init(DutyCharts);
      this.DutyCharts.setOption(this.options);
      setTimeout(() => {
        window.addEventListener("resize", () => {
          this.DutyCharts.resize();
        });
      });
    },
    getDutyPercentage() {
      this.$http.get(`/api/getDutyCalendarsNumber`).then(res => {
          if (res.status === 200) {
            console.log(res)
            this.options.series[0].data = res.data.data
            this.options.series[1].data = res.data.data
            this.options.graphic.style.text = res.data.data
            this.$nextTick(() => {
              this.initCharts()
            })
          }
        }
      )
    },
  }
}
</script>

<style scoped lang="less">
#Duty {
  width: 100%;
  height: 12vh;
  margin-top: 10px;
}
</style>
